"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchSportCountersSaga = fetchSportCountersSaga;
exports.fetchLiveSportCountersSaga = fetchLiveSportCountersSaga;
exports.fetchLineSportCountersSaga = fetchLineSportCountersSaga;
exports.fetchEventSportCountersSaga = fetchEventSportCountersSaga;
exports.fetchEventResultCountersSaga = fetchEventResultCountersSaga;
exports.fetchEventResultCountersSagaV2 = fetchEventResultCountersSagaV2;
exports.sportCountersProviderSaga = sportCountersProviderSaga;
const effects_1 = require("redux-saga/effects");
const react_fast_compare_1 = __importDefault(require("react-fast-compare"));
const dayjs_1 = __importDefault(require("dayjs"));
const saga_1 = require("../ConfigProvider/saga");
const _reduxjs_1 = require("../../utils/@reduxjs");
const utils_1 = require("./utils");
const utils_2 = require("../../utils");
const selectors_1 = require("../ResultsProvider/selectors");
const errors_1 = require("../../utils/errors");
const selectors_2 = require("../ResultsProviderV2/selectors");
const results_1 = require("../../api/results");
const ConfigProvider_1 = require("../ConfigProvider");
const selectors_3 = require("../LanguagesProvider/selectors");
const api_1 = require("../../api/sport-counters/api");
const api_2 = require("../../api/events/api");
const utils_3 = require("../../api/events/utils");
const types_1 = require("./types");
const slice_1 = require("./slice");
const selectors_4 = require("./selectors");
const constants_1 = require("./constants");
function* fetchSportCountersSaga(action) {
    const { key, reqData: payloadReqData } = action.payload;
    const isNewCountersEndpoint = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, ConfigProvider_1.EFeatureFlags.NEW_COUNTERS_ENDPOINT);
    const includeSubsports = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, ConfigProvider_1.EFeatureFlags.GENERIC_SPORT_ENABLED);
    const locale = yield (0, effects_1.select)(selectors_3.selectCurrentLangCode);
    if (isNewCountersEndpoint) {
        let defaultReqData = {};
        if (key === types_1.ESportsCounterType.LIVE) {
            defaultReqData = constants_1.DefaultCountersReq.LIVE;
        }
        else if (key === types_1.ESportsCounterType.LINE) {
            defaultReqData = constants_1.DefaultCountersReq.LINE;
        }
        const reqData = {
            ...defaultReqData,
            ...payloadReqData,
            locale,
            includeSubsports,
        };
        yield (0, effects_1.put)(slice_1.sportCountersProviderActions.fetchEventsSportCounters({
            key,
            reqData,
        }));
    }
    else if (key === types_1.ESportsCounterType.LIVE) {
        yield (0, effects_1.put)(slice_1.sportCountersProviderActions.fetchLiveSportCounters({
            aggregateByGeneric: payloadReqData === null || payloadReqData === void 0 ? void 0 : payloadReqData.aggregateByGeneric,
        }));
    }
    else if (key === types_1.ESportsCounterType.LINE) {
        yield (0, effects_1.put)(slice_1.sportCountersProviderActions.fetchLineSportCounters({
            aggregateByGeneric: payloadReqData === null || payloadReqData === void 0 ? void 0 : payloadReqData.aggregateByGeneric,
        }));
    }
    else {
        console.error(`Unsupported key for non-event counters: ${key}`);
    }
}
function* fetchLiveSportCountersSaga(action) {
    var _a;
    try {
        // TODO:PLAT-867 Remove after release
        const isGenericSportsEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, ConfigProvider_1.EFeatureFlags.GENERIC_SPORT_ENABLED);
        const requestPayload = {
            aggregateByGeneric: (_a = action.payload.aggregateByGeneric) !== null && _a !== void 0 ? _a : (isGenericSportsEnabled || undefined),
        };
        const response = yield (0, effects_1.call)(api_1.getLiveSportsCounters, requestPayload);
        const sportCounters = response.data.items;
        const newCounters = (0, _reduxjs_1.toIdsMap)(sportCounters);
        const prevCounters = yield (0, effects_1.select)((s) => (0, selectors_4.selectSportCountersByTab)(s, types_1.ESportsCounterType.LIVE));
        if (!(0, react_fast_compare_1.default)(newCounters, prevCounters)) {
            yield (0, effects_1.put)(slice_1.sportCountersProviderActions.liveSportCountersChanged(newCounters));
        }
        yield (0, effects_1.put)(slice_1.sportCountersProviderActions.fetchLiveSportCountersSuccess());
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while fetching live sport counters', error);
        yield (0, effects_1.put)(slice_1.sportCountersProviderActions.fetchLiveSportCountersError(error));
    }
}
function* fetchLineSportCountersSaga(action) {
    var _a;
    try {
        // TODO:OL-867 Remove after release
        const isGenericSportsEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, ConfigProvider_1.EFeatureFlags.GENERIC_SPORT_ENABLED);
        const requestPayload = {
            ...action.payload,
            aggregateByGeneric: (_a = action.payload.aggregateByGeneric) !== null && _a !== void 0 ? _a : (isGenericSportsEnabled || undefined),
        };
        const response = yield (0, effects_1.call)(api_1.getLineSportsCounters, requestPayload);
        const sportCounters = response.data.items;
        const newCounters = (0, _reduxjs_1.toIdsMap)(sportCounters);
        const prevCounters = yield (0, effects_1.select)((s) => (0, selectors_4.selectSportCountersByTab)(s, types_1.ESportsCounterType.LINE));
        if (!(0, react_fast_compare_1.default)(newCounters, prevCounters)) {
            yield (0, effects_1.put)(slice_1.sportCountersProviderActions.lineSportCountersChanged(newCounters));
        }
        yield (0, effects_1.put)(slice_1.sportCountersProviderActions.fetchLineSportCountersSuccess());
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while fetching line sport counters', error);
        yield (0, effects_1.put)(slice_1.sportCountersProviderActions.fetchLineSportCountersError(error));
    }
}
function* fetchEventSportCountersSaga(action) {
    var _a;
    const { key } = action.payload;
    const isGenericSportsEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, ConfigProvider_1.EFeatureFlags.GENERIC_SPORT_ENABLED);
    let reqData = (0, utils_1.formatFetchEventCountersReqData)(action.payload.reqData);
    reqData = {
        ...reqData,
        aggregateByGeneric: (_a = action.payload.reqData.aggregateByGeneric) !== null && _a !== void 0 ? _a : (isGenericSportsEnabled || undefined),
    };
    if (reqData.fiql) {
        // FIQL param must be provided by client
        // If we have met FIQL param, omit standard filters
        reqData = (0, utils_3.omitEventsCountersRequestNonFiqlFilters)(reqData);
    }
    const countersKey = key || (0, utils_2.jsonStringify)(reqData, '');
    try {
        const { data: response } = yield (0, effects_1.call)(api_2.getEventCounters, reqData);
        const newCounters = (0, utils_1.formatEventsSportCountersResponse)(response);
        const prevCounters = yield (0, effects_1.select)((s) => (0, selectors_4.selectEventSportCountersByFilterKey)(s, countersKey));
        if (!(0, react_fast_compare_1.default)(newCounters, prevCounters)) {
            yield (0, effects_1.put)(slice_1.sportCountersProviderActions.eventSportCountersChanged({
                data: newCounters,
                key: countersKey,
            }));
        }
        yield (0, effects_1.put)(slice_1.sportCountersProviderActions.fetchEventSportCountersSuccess({
            key: countersKey,
        }));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while fetching event sport counters', error);
        yield (0, effects_1.put)(slice_1.sportCountersProviderActions.fetchEventSportCountersError({
            key: countersKey,
            error,
        }));
    }
}
function* fetchEventResultCountersSaga(action) {
    var _a;
    const isGenericSportsEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, ConfigProvider_1.EFeatureFlags.GENERIC_SPORT_ENABLED);
    const { key } = action.payload;
    const date = yield (0, effects_1.select)(selectors_1.selectResultsFilterDate);
    const scheduledFrom = (0, dayjs_1.default)(date).startOf('day').format(constants_1.DATE_FORMAT);
    const scheduledTo = (0, dayjs_1.default)(date).endOf('day').format(constants_1.DATE_FORMAT);
    const reqData = {
        ...(0, utils_1.formatFetchEventCountersReqData)(action.payload.reqData),
        scheduledFrom,
        scheduledTo,
        aggregateByGeneric: (_a = action.payload.aggregateByGeneric) !== null && _a !== void 0 ? _a : (isGenericSportsEnabled || undefined),
    };
    const countersKey = key || (0, utils_2.jsonStringify)(reqData, '');
    try {
        const { data: response } = yield (0, effects_1.call)(results_1.getEventResultCounters, reqData);
        const newCounters = (0, utils_1.formatEventsSportCountersResponse)(response);
        const prevCounters = yield (0, effects_1.select)((s) => (0, selectors_4.selectEventResultCountersByFilterKey)(s, countersKey));
        if (!(0, react_fast_compare_1.default)(newCounters, prevCounters)) {
            yield (0, effects_1.put)(slice_1.sportCountersProviderActions.eventResultCountersChanged({
                data: newCounters,
                key: countersKey,
            }));
        }
        yield (0, effects_1.put)(slice_1.sportCountersProviderActions.fetchEventResultCountersSuccess({
            key: countersKey,
        }));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while fetching event result counters', error);
        yield (0, effects_1.put)(slice_1.sportCountersProviderActions.fetchEventResultCountersError({
            key: countersKey,
            error,
        }));
    }
}
function* fetchEventResultCountersSagaV2(action) {
    var _a;
    const isGenericSportsEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, ConfigProvider_1.EFeatureFlags.GENERIC_SPORT_ENABLED);
    const { key } = action.payload;
    const { scheduledFrom, scheduledTo } = yield (0, effects_1.select)(selectors_2.selectEventResultsListFilters);
    const reqData = {
        ...(0, utils_1.formatFetchEventCountersReqData)(action.payload.reqData),
        scheduledFrom,
        scheduledTo,
        aggregateByGeneric: (_a = action.payload.aggregateByGeneric) !== null && _a !== void 0 ? _a : (isGenericSportsEnabled || undefined),
    };
    const countersKey = key || (0, utils_2.jsonStringify)(reqData, '');
    try {
        const response = yield (0, effects_1.call)(results_1.getEventResultCounters, reqData);
        const newCounters = (0, utils_1.formatEventsSportCountersResponse)(response.data);
        const prevCounters = yield (0, effects_1.select)(selectors_4.selectEventResultCountersByFilterKey, countersKey);
        if (!(0, react_fast_compare_1.default)(newCounters, prevCounters)) {
            yield (0, effects_1.put)(slice_1.sportCountersProviderActions.eventResultCountersChanged({
                data: newCounters,
                key: countersKey,
            }));
        }
        yield (0, effects_1.put)(slice_1.sportCountersProviderActions.fetchEventResultCountersSuccess({
            key: countersKey,
        }));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while fetching event result counters', error);
        yield (0, effects_1.put)(slice_1.sportCountersProviderActions.fetchEventResultCountersError({
            key: countersKey,
            error,
        }));
    }
}
function* sportCountersProviderSaga() {
    yield (0, effects_1.all)([
        (0, effects_1.takeEvery)(slice_1.sportCountersProviderActions.fetchSportCounters.type, fetchSportCountersSaga),
        (0, effects_1.takeLatest)(slice_1.sportCountersProviderActions.fetchLiveSportCounters.type, fetchLiveSportCountersSaga),
        (0, effects_1.takeLatest)(slice_1.sportCountersProviderActions.fetchLineSportCounters.type, fetchLineSportCountersSaga),
        (0, effects_1.takeEvery)(slice_1.sportCountersProviderActions.fetchEventsSportCounters.type, fetchEventSportCountersSaga),
        (0, effects_1.takeLatest)(slice_1.sportCountersProviderActions.fetchEventResultCounters.type, fetchEventResultCountersSaga),
        (0, effects_1.takeLatest)(slice_1.sportCountersProviderActions.fetchEventResultCountersV2.type, fetchEventResultCountersSagaV2),
    ]);
}
//# sourceMappingURL=saga.js.map